export const GAEventsContent = {
    LOGIN: {
        category: "Login",
        action: "User clicked on Login Button from the login page",
    },
    GET_STARTED_HEADER: {
        category: "Get Started",
        action: "User clicked on the Get Started button from the header",
    },
    GET_STARTED: {
        category: "Get Started",
        action: "User clicked on the Get Started button from the overiew's Banner",
    },
    GET_STARTED_FROM_HOW_IT_WORKS: {
        category: "Get Started",
        action: "User clicked on the Get Started button from the How It Works page",
    },
    GET_IN_TOUCH: {
        category: "Get In Touch",
        action: "User clicked on the Get n Touch button on the Overview page",
    },
    LEARN_MORE: {
        category: "Learn More",
        action: "User clicked on the learn more link of How It Works page",
    },
    ENROLL_CONTINUE: {
        category: "Continue",
        action: "User clicked on the continue button of the Enroll Page",
    },
    HEADER_CONTINUE: {
        category: "Continue",
        action: "User clicked on the continue button from the Header",
    },
};
